import { EmptyStateCard } from "@/components/podkit/EmptyStateCard";
import { LoadingState } from "@/components/podkit/loading/LoadingState";
import { Button } from "@/components/flexkit/Button";
import { useListServiceAccounts } from "@/queries/service-account-queries";
import { ServiceAccountsList } from "@/components/settings/organization/service-accounts/ServiceAccountsList";
import type { FC } from "react";

type ServiceAccountsTabProps = {
    onCreateServiceAccount?: () => void;
    canCreateServiceAccount?: boolean;
};

export const ServiceAccountsTab: FC<ServiceAccountsTabProps> = ({
    onCreateServiceAccount,
    canCreateServiceAccount = true,
}) => {
    const { data, isLoading, error } = useListServiceAccounts();
    const serviceAccounts = data?.serviceAccounts || [];

    if (isLoading) {
        return <LoadingState />;
    }

    if (error) {
        return (
            <div className="flex items-center justify-center py-12">
                <p className="text-content-secondary">Failed to load service accounts</p>
            </div>
        );
    }

    if (serviceAccounts.length === 0) {
        return (
            <EmptyStateCard
                title="You don't have any service accounts yet"
                description="Use them to run workflows, manage integrations, or automate actions without using a personal account."
                data-testid="service-accounts-empty-state"
            >
                {canCreateServiceAccount && (
                    <Button
                        variant="primary"
                        size="sm"
                        data-tracking-id="new-service-account"
                        onClick={onCreateServiceAccount}
                    >
                        New Service Account
                    </Button>
                )}
            </EmptyStateCard>
        );
    }

    return <ServiceAccountsList serviceAccounts={serviceAccounts} />;
};
